import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stack-overflow': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M290.7 311l-8.2 39-195.7-41 8.2-39.3zM341.7 224l-25.5 30.8-153.5-128.3 25.5-30.8zM310.5 263.7l-16.8 36.3-181.2-84.5 16.7-36.5zM262 32l119.3 160.3-32 24-119.3-160.3zM282.5 360v39.7h-200v-39.7h200zM322.2 440v-120h40v160h-359.5v-160h40v120h279.5z'
      }
    ]
  }
})
